import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import searchIcon from "./../../media/search-icon.svg";
import Logger from "../../utils/Logger";
import { LoadingComponent } from "../../App.js";
import httpClient from "../../services/httpClient";

const DHL = () => {
  const { t } = useTranslation();
  const [trackingId, setTrackingId] = useState("");
  const [trackingData, setTrackingData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!trackingId.trim()) {
      setError(t("logistics.enterTrackingNumber"));
      setTrackingData(null);
      setHasSearched(false);
      return;
    }

    setLoading(true);
    setError(null);
    setTrackingData(null);
    setHasSearched(true);

    try {
      Logger.log(`Śledzenie przesyłki DHL: ${trackingId}`);
      const response = await httpClient.get(`/Dhl/tracking/${trackingId}`, {
        withAuth: true,
      });

      setTrackingData(response.data);
      setError(null);
      Logger.log("Dane śledzenia otrzymane:", response.data);
    } catch (error) {
      Logger.error("Błąd podczas śledzenia przesyłki:", error);
      if (error.response?.status === 404) {
        setError(t("logistics.noParcelFound"));
      } else if (error.response?.status === 400) {
        setError(t("logistics.invalidTrackingNumber"));
      } else {
        setError(t("logistics.errorTracking"));
      }
      setTrackingData(null);
    } finally {
      setLoading(false);
    }
  };

  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString("pl-PL", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "DOR":
        return "green"; // Doręczona
      case "LK":
        return "#8B4513"; // U kuriera (brązowy)
      case "LP":
        return "blue"; // W oddziale
      case "DWP":
        return "purple"; // Odebrana od nadawcy
      case "SORT":
        return "gray"; // W sortowni
      default:
        return "black";
    }
  };

  return (
    <div className="dhl-service-checker">
      <h1>{t("logistics.dhlTracking")}</h1>

      <form className="formularz" onSubmit={handleSubmit}>
        <label htmlFor="trackingId">
          <div className="input-container">
            <input
              type="text"
              name="trackingId"
              id="trackingId"
              placeholder={t("logistics.trackingNumber")}
              value={trackingId}
              onChange={(e) => setTrackingId(e.target.value)}
            />
            <img
              src={searchIcon}
              alt="search Icon"
              className="search-icon"
              onClick={handleSubmit}
            />
          </div>
        </label>
        <div className="check">
          <input
            type="submit"
            value={loading ? t("logistics.checking") : t("logistics.track")}
            disabled={loading}
          />
        </div>
      </form>

      {error && <div className="error">{error}</div>}

      {loading && hasSearched && <LoadingComponent />}

      {trackingData && !loading && (
        <div className="tracking-info">
          <h2>
            Informacje o przesyłce <b>{trackingData.shipmentId}</b>{" "}
            {trackingData.receivedBy && (
              <p>Odebrana przez: {trackingData.receivedBy}</p>
            )}
          </h2>

          <h3>Historia przesyłki:</h3>
          <div className="tracking-timeline">
            {trackingData.events && trackingData.events.length > 0 ? (
              trackingData.events.map((event, index) => (
                <div key={index} className="tracking-event">
                  <div className="event-content">
                    <div className="event-header">
                      <span
                        className="event-status"
                        style={{ color: getStatusColor(event.status) }}
                      >
                        {event.status}
                      </span>
                      {event.location && (
                        <span className="event-location">{event.location}</span>
                      )}
                      <span className="event-timestamp">
                        {formatTimestamp(event.timestamp)}
                      </span>
                    </div>
                    <div className="event-description">{event.description}</div>
                  </div>
                </div>
              ))
            ) : (
              <p>Brak danych o wydarzeniach dla tej przesyłki.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DHL;
